import { render, staticRenderFns } from "./BStep2.vue?vue&type=template&id=b70b861a&scoped=true"
import script from "./BStep2.vue?vue&type=script&lang=js"
export * from "./BStep2.vue?vue&type=script&lang=js"
import style0 from "./BStep2.vue?vue&type=style&index=0&id=b70b861a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70b861a",
  null
  
)

export default component.exports